import { success, failure, request } from 'app/actions';
import * as actions from './simulatedCorrectionActions';
import * as helpers from '../simulatedHelpers';
import * as correctionHelpers from './simulatedCorrectionHelpers';

const initialState = {
  evaluation: {
    evaluation: {
      catalogings: [],
      idString: '',
      idStep:0,
      levelSegment: [],
    },
  },
  updateAnswerSheet: {
    error: undefined,
  },
  schoolOptions: [],
  contract: {},
  completed: false,
  error: null,
  isLoading: false,
  correctionInProgress: false,
  correctionFinalized: false,
  correctionGoNext: false,
  correctionsWithSuccess: 0,
  correctionsResponses: [],
  studentAnswerList: [],
  correctAnswerSheetState: {
    error: undefined,
    errCode: undefined,
  },
  studentAnswer: {
    questions: [],
    message: '',
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.SET_LOADING:
      return { ...state, isLoading: action.payload };
    case actions.RESET_CORRECTION:
      return {
        ...state,
        error: null,
        isLoading: false,
        correctionInProgress: false,
        correctionFinalized: false,
        correctionGoNext: false,
        correctionsWithSuccess: 0,
        correctionsResponses: [],
      };
    case actions.CORRECTION_IN_PROGRESS:
      return {
        ...state,
        correctionInProgress: action.payload,
        isLoading: action.payload,
      };
    case actions.CORRECTION_FINALIZED:
      return {
        ...state,
        isLoading: true,
        correctionFinalized: action.payload,
        //isLoading: !action.payload,
      };
    case actions.CORRECTION_GO_NEXT:
      return { ...state, correctionGoNext: action.payload };
    case actions.CORRECTION_WITH_SUCCESS:
      return { ...state, correctionsWithSuccess: action.payload };
    case actions.CORRECTION_RESPONSES:
      return { ...state, correctionsResponses: action.payload || [] };
    case request(actions.CORRECT_ANSWER_SHEET):
      return {
        ...state,
        error: null,
        errCode: null,
        isLoading: true,
        correctAnswerSheetState: {
          error: initialState.correctAnswerSheetState.error,
          errCode: initialState.correctAnswerSheetState.errCode,
        },
      };
    case success(actions.CORRECT_ANSWER_SHEET):
      const correctionsResponsesSuccess = state.correctionsResponses;
      correctionsResponsesSuccess.push({ success: true, message: action.payload.success });
      return {
        ...state,
        correctionsWithSuccess: state.correctionsWithSuccess + 1,
        correctionGoNext: true,
        correctionsResponses: correctionsResponsesSuccess,
        correctAnswerSheetState: {
          error: initialState.correctAnswerSheetState.error,
          errCode: initialState.correctAnswerSheetState.errCode,
        },
      };
    case failure(actions.CORRECT_ANSWER_SHEET):
      const correctionsResponsesFailure = state.correctionsResponses;
      correctionsResponsesFailure.push({ success: false, message: action.payload.error });
      return {
        ...state,
        error: action.payload.error,
        errCode: action.payload.errCode,
        isLoading: false,
        correctionGoNext: true,
        correctionsResponses: correctionsResponsesFailure,
        correctAnswerSheetState: {
          error: action.payload.error,
          errCode: action.payload.errCode,
        },
      };
    case request(actions.GET_EVALUATION_INFORMATION):
      return {
        ...state,
        evaluation: initialState.evaluation,
        completed: initialState.completed,
        forbidden: initialState.forbidden,
        students: initialState.students,
        totalWarning: initialState.totalWarning,
        isLoading: false,
      };
    case success(actions.GET_EVALUATION_INFORMATION):
      return {
        ...state,
        evaluation: helpers.getEvaluationInformation(action.payload.content),
        schoolOptions: helpers.getSchoolCSOptions(action.payload.content),
        contract: action.payload.content.contract,
        completed: action.payload.content.evaluation.dates.some(
          (d) => d.component === 'diagramming' && d.complete,
        ),
        forbidden: false,
      };
    case failure(actions.GET_EVALUATION_INFORMATION):
      return {
        ...state,
        forbidden: true,
        isLoading: false,
      };
    case success(actions.GET_STUDENT_ANSWER_LIST):
      return {
        ...state,
        students: action.payload.content.students
          ? action.payload.content.students
          : initialState.students,
        totalWarning: action.payload.content.totalWarning || initialState.totalWarning,
      };
    case request(actions.GET_STUDENT_ANSWER_DETAIL):
      return {
        ...state,
        studentAnswer: initialState.studentAnswer,
      };
    case success(actions.GET_STUDENT_ANSWER_DETAIL):
      return {
        ...state,
        studentAnswer: {
          ...action.payload.studentAnswer,
          message: action.payload.content,
          questions: correctionHelpers.getQuestions(action.payload.studentAnswer),
        },
      };
    case request(actions.UPDATE_ANSWER_SHEET):
      return {
        ...state,
        updateAnswerSheet: {
          error: initialState.updateAnswerSheet.error,
        },
      };
    case success(actions.UPDATE_ANSWER_SHEET):
      return {
        ...state,
        updateAnswerSheet: {
          error: initialState.updateAnswerSheet.error,
        },
      };
    case failure(actions.UPDATE_ANSWER_SHEET):
      return {
        ...state,
        updateAnswerSheet: {
          error: action.payload.content,
        },
      };
    default:
      return state;
  }
};

export default reducer;
